<template>
  <el-container style="height: 100vh; overflow: hidden">
    <el-header style="padding: 0px; height: auto">
      <top-menu :isCollapse="isCollapse" @toggleMenu="toggleMenu"></top-menu>
    </el-header>
    <el-container>
      <el-aside style="height: 100vh; width: auto">
        <left-menu :isCollapse="isCollapse"></left-menu>
      </el-aside>
      <el-main
        v-if="isRouterShow"
        :style="{
          height: clientHeight,
          overflow: 'auto',
          backgroundColor: '#F1F1F2',
        }"
      >
        <HeadNavigation></HeadNavigation>
        <transition
          name="fade-transform"
          mode="out-in"
          :duration="{ enter: 200, leave: 300 }"
        >
          <keep-alive :include="aliveList">
            <router-view
              ref="routewidth"
              class="home_bg"
              :style="{ minHeight: routeHeight, overflow: 'auto' }"
            ></router-view>
          </keep-alive>
        </transition>
      </el-main>
    </el-container>
    <download-dialog></download-dialog>
  </el-container>
</template>

<script>
import LeftMenu from "./left_menu_bar/left_menu_bar.vue";
import TopMenu from "./top_menu_bar/top_menu_bar.vue";
import HeadNavigation from "./head_navigation/head_navigation.vue";
import { mapGetters } from "vuex";
import { DownloadDialog } from "../../widget";
export default {
  components: { LeftMenu, TopMenu, HeadNavigation, DownloadDialog },
  provide() {
    return {
      reload: this.reload, //中英文切换重新加载路由组件
    };
  },
  data() {
    return {
      isCollapse: true,
      // height:'100vh',
      clientHeight: "100vh",
      routeHeight: "",
      isRouterShow: true, //中英文切换重新加载路由组件
    };
  },
  computed: {
    ...mapGetters({ aliveList: "keepAlivePage" }),
  },
  created() {
    this.routeHeight = document.body.clientHeight - 195 + "px";
    this.clientHeight = document.body.clientHeight - 40 + "px";
    window.onresize = () => {
      this.clientHeight = document.body.clientHeight - 40 + "px";
      this.routeHeight = document.body.clientHeight - 195 + "px";
    };
  },
  methods: {
    toggleMenu(val) {
      this.isCollapse = val;
    },
    //中英文切换重新加载路由组件
    async reload() {
      this.isRouterShow = false;
      await this.$nextTick();
      this.isRouterShow = true;
    },
  },
};
</script>

<style scoped>
.home_bg {
  background-color: #fff;
}
</style>